'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _with_upload_sign = require('../hocs/with_upload_sign');

var _with_upload_sign2 = _interopRequireDefault(_with_upload_sign);

var _template_form = require('../components/template_form');

var _template_form2 = _interopRequireDefault(_template_form);

var _template = require('../actions/template');

var _with_product_type = require('../hocs/with_product_type');

var _with_product_type2 = _interopRequireDefault(_with_product_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplateEdit = _react2.default.createClass({
    displayName: 'TemplateEdit',
    handleSubmit: function handleSubmit(values) {
        this.props.dispatch((0, _template.postTemplateIfNeeded)(values, this.props.router));
    },
    render: function render() {
        var _props = this.props,
            templates = _props.templates,
            productTypes = _props.productTypes,
            params = _props.params,
            uploadSign = _props.uploadSign,
            token = _props.token;

        var template = templates.filter(function (o) {
            return o.id == params.templateID;
        })[0];
        return _react2.default.createElement(
            'div',
            { id: 'template-edit' },
            _react2.default.createElement(_template_form2.default, { template: template, types: productTypes, uploadSign: uploadSign, token: token, onSubmit: this.handleSubmit })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var templates = store.template.templates;
    var uploadSign = store.uploadSign,
        auth = store.auth;
    var productTypes = store.productType.productTypes;

    return {
        templates: templates.items,
        uploadSign: uploadSign,
        productTypes: productTypes.items,
        token: auth.token
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _with_upload_sign2.default)((0, _with_product_type2.default)(TemplateEdit)));


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/template_edit.js
// module id = 1341
// module chunks = 0